/**
 * Blokkeert formulieren waarvan het honeypot-veld is ingevuld — vóór alle andere
 * submit-handlers op de pagina.
 *
 * Waarom deze laag bovenop de honeypots die de formulieren zelf al hadden
 * (apc-email-signup, apc-blog-email-capture, apc-exit-intent-popup,
 * apc-back-in-stock): die gates zitten in de eigen submit-handler van het
 * formulier. klaviyo.js luistert óók op document en maakt bij een ingezonden
 * e-mailveld een profiel aan — dat gebeurt buiten die gates om. Zo ontstonden de
 * botprofielen die op NEVER_SUBSCRIBED binnenkwamen en hard bouncten
 * (meting 30-08-2026, docs/analysis/klaviyo-bots-welkomstflow-meting-2026-08-18.md).
 *
 * Daarom capture-fase op document plus stopPropagation: het event bereikt noch de
 * eigen handlers, noch klaviyo.js. Een geblokkeerde inzending doet dus zichtbaar
 * niets meer — dat is het verschil met de oude gates, die bewust het succesbeeld
 * toonden zodat een bot niet blijft herhalen.
 *
 * Grens: dit werkt in de browser. Een bot die rechtstreeks POST naar /contact of
 * naar de Klaviyo-API slaat het over.
 */
(function () {
  'use strict';

  var POTTEN = 'input[name="apc_website"], input[name="company_website"]';

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.querySelectorAll !== 'function') return;

      var gevuld = false;
      var potten = form.querySelectorAll(POTTEN);
      for (var i = 0; i < potten.length; i++) {
        if (potten[i].value.trim() !== '') {
          gevuld = true;
          potten[i].value = '';
        }
      }
      if (!gevuld) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})();
